import type { Observable } from 'rxjs/Observable';
import type { CategoryId } from '../../types.tsx';
import {
	list as listArticles,
	listCategoryArticles,
	getAllLinkedSpaces,
	type ListOptions,
	type ListArticlesResponse,
	type SpacesResponse,
} from '../rest/articles/index.tsx';

type ListArticlesOptions = ListOptions & {
	categoryId: CategoryId;
};

export const list = (
	projectId: number,
	activationId: string,
	{ categoryId, ...opts }: ListArticlesOptions,
): Observable<ListArticlesResponse> => {
	if (categoryId === 'all-articles') {
		return listArticles(projectId, opts, activationId);
	}

	return listCategoryArticles(projectId, categoryId, opts, activationId);
};

export const linkedSpaces = (projectKey: string): Observable<SpacesResponse> =>
	getAllLinkedSpaces(projectKey);
